import React from 'react';
import ArrowLeftIcon from "../icons/ArrowLeftIcon";
import {IconSize} from "../services/IconConstants";
import {useNavigate} from "react-router-dom";

interface Props {
}

const GoBackArrow = ({}: Props) => {

    const nav = useNavigate();

    const goBack = () => {
        nav(-1)
    }

    return (
        <div style={{ display: "flex", flexDirection: 'row', gap: '8px', width: 'fit-content', marginBottom: '16px', alignItems: 'center' }} onClick={goBack}>
            <ArrowLeftIcon size={IconSize.md} />
            <span>Go Back</span>
        </div>
    )
}

export default GoBackArrow;